module.exports = __webpack_public_path__ + "img/4-krabpalen.c28804df.jpg";